import { createAction } from '@reduxjs/toolkit'

import { TGroupApi, GroupMember } from 'types/GlobalGroup'

// tryGetAllGroups
export const getAll = createAction('get_all_groups')
export const getAllSuccess = createAction<{ data: TGroupApi[] }>(
  'get_all_groups_success'
)
export const getAllFailed = createAction('get_all_groups_failed')

// tryCreateGroup
export const create = createAction('create_group')
export const createSuccess = createAction<{ data: TGroupApi }>(
  'create_group_success'
)
export const createFailed = createAction('create_group_failed')

// tryUpdateGroup
export const update = createAction('update_group')
export const updateSuccess = createAction<{ data: TGroupApi }>(
  'update_group_success'
)
export const updateFailed = createAction('update_group_failed')

// tryDeleteGroup
export const destroy = createAction('delete_group')
export const destroySuccess = createAction<string>('delete_group_success')
export const destroyFailed = createAction('delete_group_failed')

// tryAddMetricToGroup
export const addMetric = createAction('add_metric_to_group')
export const addMetricSuccess = createAction<{ data: TGroupApi }>(
  'add_metric_to_group_success'
)
export const addMetricFailed = createAction('add_metric_to_group_failed')

// tryAddKeyMetricToGroup
export const addKeyMetric = createAction('add_key_metric_to_group')
export const addKeyMetricSuccess = createAction<{ data: TGroupApi }>(
  'add_key_metric_to_group_success'
)
export const addKeyMetricFailed = createAction('add_key_metric_to_group_failed')

// tryRemoveMetricFromGroup
export const removeMetric = createAction('remove_metric_from_group')
export const removeMetricSuccess = createAction<{ data: TGroupApi }>(
  'remove_metric_from_group_success'
)
export const removeMetricFailed = createAction(
  'remove_metric_from_group_failed'
)

// tryRemoveKeyMetricFromGroup
export const removeKeyMetric = createAction('remove_key_metric_from_group')
export const removeKeyMetricSuccess = createAction<{ data: TGroupApi }>(
  'remove_key_metric_from_group_success'
)
export const removeKeyMetricFailed = createAction(
  'remove_key_metric_from_group_failed'
)

// tryUpdateGroupMember
export const updateMember = createAction('update_group_member')
export const updateMemberSuccess = createAction<{
  member: GroupMember
  groupId: string
}>('update_group_member_success')
export const updateMemberFailed = createAction('update_group_member_failed')

// tryDeleteGroupMember
export const deleteMember = createAction('delete_group_member')
export const deleteMemberSuccess = createAction<{
  id: string
  groupId: string
}>('delete_group_member_success')
export const deleteMemberFailed = createAction('delete_group_member_failed')

// Group pin actions (used from KeyMetrics actions)
export const pinKeyMetricOnGroupSuccess = createAction<{
  groupId: string
  pin: { id: string; comment: string | null; key_metric_id: string }
}>('pin_key_metric_on_group_success')

export const unpinKeyMetricOnGroupSuccess = createAction<{
  groupId: string
  pinId: string
}>('unpin_key_metric_on_group_success')

export const updateGroupPinCommentSuccess = createAction<{
  comment: string
  groupId: string
  pinId: string
}>('update_group_pin_comment_success')

// Dashboard actions (used from other actions)
export const appendToDashboard = createAction<{
  groupId: string
  dashboardGroupId: string
}>('append_dashboard_to_group')
export const removeFromDashboard = createAction<{
  groupId?: string
  dashboardGroupId: string
}>('remove_dashboard_from_group')
